import React, { Component, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSwipeable } from 'react-swipeable'
require('./expand.css');

const Expand = ({expanded=false , collapsedHeight , enabled = true , childRef, delta, expandButton, children})=>{
    const ExpandButton = expandButton;
    const windowHeight = window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight;
    const initialState = {
        animation:false,
        expanded,
        height: expanded ? '100%' : collapsedHeight,
        enabled,
        initialHeight:0,
        maxHeight:windowHeight - 80
    };
    const [state , setState] = useState(initialState);

    const preventExpand = (e) => {
        e.stopImmediatePropagation();
    }

    useEffect(()=>{
        const childHeight = childRef.current.getBoundingClientRect().height + 25;
        const newMaxHeight = childHeight > state.maxHeight && state.maxHeight ? state.maxHeight : childHeight;
        setState({...state ,maxHeight: newMaxHeight });
        return ()=> {
            let eventsList =  document.querySelectorAll('.swipe-expand  [data-prevent-expand]');
            for (let i=0; i< eventsList.length; i++){
                eventsList[i].removeEventListener("touchstart", preventExpand);
                eventsList[i].removeEventListener("touchmove", preventExpand);
                eventsList[i].removeEventListener("touchend", preventExpand);
            }
        }
    },[]);

    useEffect(()=>{
        setState({
          ...state,
          height: state.expanded ? state.maxHeight : collapsedHeight,
          enabled: enabled,
        });

        let eventsList =  document.querySelectorAll('.swipe-expand  [data-prevent-expand]');
        for (let i=0; i< eventsList.length; i++){
            eventsList[i].removeEventListener("touchstart", preventExpand);
            eventsList[i].removeEventListener("touchmove", preventExpand);
            eventsList[i].removeEventListener("touchend", preventExpand);
            if (eventsList[i].scrollHeight > eventsList[i].clientHeight ) {
                eventsList[i].addEventListener("touchstart", preventExpand);
                eventsList[i].addEventListener("touchmove", preventExpand);
                eventsList[i].addEventListener("touchend", preventExpand);
            }
        } 
    },[state.expanded , state.enabled]);
    
    const onSwipeMove = (event) => {
        let initialHeight = collapsedHeight;
        if (state.expanded) {
            initialHeight = state.maxHeight;
        }
        let height = initialHeight - event.deltaY;
        if (height > state.maxHeight) {
            height = state.maxHeight;
        }
        if (height < collapsedHeight) {
            height = collapsedHeight;
        }
        if (state.enabled && Math.abs(initialHeight - height) >  delta ) {
            setState({
                ...state,
                animation: false,
                height: height,
            });
        }
        
    }

    const onSwipeEnd = (event)=> {
        let height = state.height;
        let expanded = state.expanded;
        if (event.velocity < 1.1 || event.dir == "Left" || event.dir == "Right") {
            if ((state.maxHeight - collapsedHeight)  / 2 < (height - collapsedHeight)) {
                height = state.maxHeight;
                expanded = true;
            } else {
                height = collapsedHeight;
                expanded = false;
            }
        } else {
            if (expanded && event.dir == "Up") {
                expanded = false;
                height = collapsedHeight;
            } 
            if (!expanded && event.dir == "Down"){
                expanded = true;
                height = state.maxHeight;
            }
        }

        
        if (state.enabled) { 
            setState({
                ...state,
                animation: true,
                height: height,
                expanded: expanded,
            });
        }
    }

    const showMoreHandler=()=> {
        setState({
            ...state,
            animation: true,
            expanded: !state.expanded
        });
    }   

    const config = {    
        preventScrollOnSwipe:true    
      }
    
      const handlers = useSwipeable({
        onSwiping:() => onSwipeMove,
        onSwiped :() => onSwipeEnd,
        ...config,
      });
    
      const myRef = useRef();
    
      const refPassthrough = (el) => {
        // call useSwipeable ref prop with el
        handlers.ref(el);
    
        // set myRef el so you can access it yourself
        myRef.current = el;
      }


    return (
      <div
        className="swipe-expand-wrapper"
        style={{
          position: "relative",
        }}
      >
        <div
          {...handlers}
          ref={refPassthrough}         
        >
          <div
            className={`shadow-depth-1 ${
              state.animation ? "expand-animation" : ""
            } swipe-expand`}
            style={{
              minHeight: collapsedHeight,
              height: state.height,
            }}
          >
            {children({
              height: state.height,
              expanded: state.expanded,
              enabled: state.enabled,
              maxHeight: state.maxHeight,
            })}
          </div>
          {state.enabled && (
            <div
              className={`${
                state.animation ? "expand-animation" : ""
              } swipe-expand__button-wrapper`}
              style={{ top: state.height - 16 }}
              onClick={showMoreHandler}
            >
              <ExpandButton expanded={state.expanded} />
            </div>
          )}
        </div>
      </div>
    );
}

Expand.defaultProps = {
    maxHeight: 0,
    enabled: true,
}

Expand.propTypes = {
    maxHeight: PropTypes.number,
    enabled: PropTypes.bool,
}

Expand.propDescriptions = {
}

export default Expand;